import { render, staticRenderFns } from "./Frund.vue?vue&type=template&id=0e93e13a&"
import script from "./Frund.vue?vue&type=script&lang=js&"
export * from "./Frund.vue?vue&type=script&lang=js&"
import style0 from "./Frund.vue?vue&type=style&index=0&id=0e93e13a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports